import { CloseOutlined, RightOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import cn from 'classnames';

import type { MenuProps } from 'antd';
import type { FC, KeyboardEvent, MouseEvent, ReactNode } from 'react';

import './SidebarBanner.scss';

interface SidebarBannerProps {
  icon: ReactNode;
  title: string;
  subtitle: string;
  variant: 'primary' | 'warning' | 'danger';
  onClick: () => void;
  isSmall?: boolean;
  closeMenu?: MenuProps;
  closeAriaLabel?: string;
  dataTestId?: string;
}

export const SidebarBanner: FC<SidebarBannerProps> = ({
  icon,
  title,
  subtitle,
  variant,
  onClick,
  isSmall,
  closeMenu,
  closeAriaLabel,
  dataTestId,
}) => {
  const keyDownHandler = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  const closeClickHandler = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
  };

  return (
    <div
      className={cn('SidebarBanner', `SidebarBanner--${variant}`, {
        'SidebarBanner--small': isSmall,
      })}
      role="button"
      tabIndex={0}
      data-testid={dataTestId}
      onClick={onClick}
      onKeyDown={keyDownHandler}
    >
      <span className="SidebarBanner__icon">{icon}</span>
      {!isSmall && (
        <span className="SidebarBanner__text">
          <span className="SidebarBanner__title">{title}</span>
          <span className="SidebarBanner__subtitle">{subtitle}</span>
        </span>
      )}
      {!isSmall && !closeMenu && (
        <span className="SidebarBanner__chevron">
          <RightOutlined />
        </span>
      )}
      {closeMenu && (
        <Dropdown menu={closeMenu} trigger={['click']} placement="bottomRight">
          <button
            type="button"
            className="SidebarBanner__close"
            aria-label={closeAriaLabel}
            onClick={closeClickHandler}
          >
            <CloseOutlined />
          </button>
        </Dropdown>
      )}
    </div>
  );
};
